module.exports = __webpack_public_path__ + "img/ProfilePicture.d1351b0c.svg";